import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseEventViewing } from 'entities/Viewing'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type ConversationMessagesStore } from 'widgets/ConversationMessages'

export const useEventViewing = (conversationMessageStore: ConversationMessagesStore) => {
  const { websocket } = useEntitiesContext()
  const handler = (data: IResponseEventViewing) => {
    conversationMessageStore.handleViewingEvent(data)
  }

  useEffect(() => websocket.on(WebsocketEvent.ClientViewing, handler), [])
}
